import {Inject, Injectable} from '@angular/core';
import {Owner} from './owner.model';
import {AppConfig} from '../config/app.config';
import {HttpClient} from '@angular/common/http';
import {CrudService} from '@ngx-ivengi/crud';

@Injectable()
export class OwnerService extends CrudService<Owner> {
  public entityType = Owner;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/owner/owner.service.ts